import { create } from 'zustand'

const useSettlementStore = create((set) => ({
  shouldRefreshApi: false,
  refreshApi: () => set((state) => ({ shouldRefreshApi: !state.shouldRefreshApi})),
}))

export default useSettlementStore